export default __webpack_public_path__ + "media/images/corporate/apartments/third_slide_sm-57c626b8f21652b89242598eb0041da6.png";